import Layout from "components/layout/Layout";
const SafetyOverview = () => {
    return (
        <Layout
            headerStyle={1}
            footerStyle={1}
            breadcrumbTitle={ <> Safety <span>Overview</span> </> } >
            <section className="job-details-area pb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="job-details-content">
                                <div className="job-qualifications">
                                    <p className="info-one">
                                        Your safety matters. BodyLytiX promotes responsible fitness with personalized AI insights, science-based recommendations, and robust data protection. Trust in our platform to support your journey securely and sustainably.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>1. Data Security</strong>
                                    <p>
                                        Your personal information and fitness data are safeguarded with the highest standards of security:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Encryption: 
                                            </strong>
                                            <span> We use advanced encryption to protect your data during transmission and storage.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                AWS Hosting: 
                                            </strong>
                                            <span> Our platform is built on Amazon Web Services (AWS), ensuring enterprise-grade security and compliance with global standards.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Regular Monitoring: 
                                            </strong>
                                            <span> Our systems are continuously monitored for vulnerabilities and potential threats to keep your data safe.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>2. Privacy Protection</strong>
                                    <p>
                                    We respect your privacy and give you control over your data:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Transparency: 
                                            </strong>
                                            <span> You know how your data is collected, used, and shared.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                User Control: 
                                            </strong>
                                            <span> Manage your privacy settings, including data sharing and integrations.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Compliance: 
                                            </strong>
                                            <span> We adhere to global privacy laws like GDPR to ensure your information is handled responsibly.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>3. Health and Wellness Guidance</strong>
                                    <p>
                                    BodyLytiX supports a safe and balanced approach to fitness and wellness:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Personalized Insights: 
                                            </strong>
                                            <span> Our AI-powered insights are tailored to your fitness level, goals, and data, helping you progress at a pace that suits you.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Science-Based Recommendations: 
                                            </strong>
                                            <span> Our features are designed based on evidence-based practices to encourage healthy habits and avoid overtraining or injury.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Community Standards: 
                                            </strong>
                                            <span> We foster a supportive and respectful community to ensure a positive environment for all users.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>4. Responsible Use of Data</strong>
                                    <p>
                                        We prioritize the ethical use of your data to enhance your experience:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Anonymized Analytics: 
                                            </strong>
                                            <span> Aggregated and anonymized data is used for research and feature development without compromising your privacy.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                User Consent: 
                                            </strong>
                                            <span> Data sharing only occurs with your explicit permission.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>5. Safety Tips for Users</strong>
                                    <p>
                                    To maximize your safety while using BodyLytiX, we recommend:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Listening to Your Body: 
                                            </strong>
                                            <span> Avoid pushing yourself beyond your limits and take rest days as needed.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Consulting Professionals: 
                                            </strong>
                                            <span> Seek advice from qualified trainers, nutritionists, or healthcare providers for personalized support.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Staying Informed: 
                                            </strong>
                                            <span> Read and follow the recommendations provided by our AI Coaches, tailored to your individual needs.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <p className="info-one">
                                        At BodyLytiX, we’re committed to helping you achieve your goals in a safe, secure, and responsible manner. Your well-being is our mission, and we are always here to support you. If you have any questions or concerns, please contact us at &nbsp;
                                        <a href="mailto:support@bodylytix.ai">
                                            support@bodylytix.ai
                                        </a>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};
export default SafetyOverview;